"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const ActionTypes = require("../../actionTypes/reports/fieldsModal");
exports.initialState = {
    fieldsModalIsOpen: false,
    reportUuid: null,
    mode: 'CREATE'
};
const isOpenLens = monocle.Lens.fromProp('fieldsModalIsOpen');
const reportUuidLens = monocle.Lens.fromProp('reportUuid');
const modeLens = monocle.Lens.fromProp('mode');
exports.methods = {};
exports.methods[ActionTypes.FIELDS_MODAL_OPEN] = (state, action) => fp.function.flow(isOpenLens.set(true), modeLens.set(action.payload.mode), reportUuidLens.set(action.payload.reportUuid))(state);
exports.methods[ActionTypes.FIELDS_MODAL_CLOSE] = (state, _action) => fp.function.flow(isOpenLens.set(false), reportUuidLens.set(null))(state);
//# sourceMappingURL=fieldsModal.js.map